import React from 'react';
import { Spin } from 'antd';
import s from './s.module.less';
import SafetyInfoContentItem from './SafetyInfoContentItem';
import {
    DataManager,
    TabDataManager,
} from '../../utils/dataUpdater';
import { TSafetyInfoMgmt } from '../../type';
import SafetyInfoContentModal from './SafetyInfoContentModal';

type Props = {
    dataManager: DataManager;
};

const SafetyInfoMgmt = ({ dataManager }: Props) => {
    const [loading] = React.useState(false);
    const [contentModalVisible, setContentModalVisible] = React.useState(false);
    const [selectedSafetyInfo, setSelectedSafetyInfo] = React.useState<TSafetyInfoMgmt | undefined>(undefined);

    // 为safetyInfoMgmt tab创建独立的数据管理器
    const [safetyInfoTabManager] = React.useState<TabDataManager>(() => {
        return dataManager.createTabManager('safetyInfoMgmt');
    });

    // 从tab数据管理器获取safetyInfoMgmt数据
    const safetyInfoMgmtData = safetyInfoTabManager.getTabData('safetyInfoMgmt');

    const handleSafetyInfoSave = async (data: TSafetyInfoMgmt) => {
        try {
            // 更新safety info数据
            safetyInfoTabManager.updateTabData('criticalSafetyInformation', data.criticalSafetyInformation);
            safetyInfoTabManager.updateTabData('generalSafetyConsiderations', data.generalSafetyConsiderations);

            // 保存到服务器
            await dataManager.saveDataToServer(
                () => {
                    setContentModalVisible(false);
                    setSelectedSafetyInfo(undefined);
                },
                (error: any) => {
                    console.error('Failed to save safety info:', error);
                },
            );
        } catch (error) {
            console.error('Error in handleSafetyInfoSave:', error);
        }
    };

    const handleContentEdit = () => {
        setSelectedSafetyInfo(safetyInfoMgmtData);
        setContentModalVisible(true);
    };

    return (
        <div className={s.wrap}>
            <div className={s.title}>
                Safety info management
            </div>

            <Spin spinning={loading}>
                <div className={s.contentSection}>
                    <SafetyInfoContentItem
                        criticalSafetyInformation={safetyInfoMgmtData?.criticalSafetyInformation || 'Critical safety information'}
                        generalSafetyConsiderations={safetyInfoMgmtData?.generalSafetyConsiderations || []}
                        onEdit={() => handleContentEdit()}
                    />
                </div>
            </Spin>

            {/* Safety Info Content Modal */}
            <SafetyInfoContentModal
                visible={contentModalVisible}
                onCancel={() => {
                    setContentModalVisible(false);
                    setSelectedSafetyInfo(undefined);
                }}
                onSave={handleSafetyInfoSave}
                initialData={selectedSafetyInfo}
            />
        </div>
    );
};

export default SafetyInfoMgmt;
